import { useContext } from "react";
import { AuthContext } from "./AuthContext";
export var useAuthContext = function () {
    var context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
